import { AvailableRate } from "@/@types/Rating/AvailableRate";
import { carrierLogosUrl } from "@/utils/images";
import Image from "next/image";
import React from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import classes from "@/styles/get-quotes/get-quotes-main.module.css";
import RateDetailsPopover from "../utils/rate-details-popover";

interface Props {
  top3Rates: AvailableRate[];
  handleChooseRate: () => void;
}
const ChooseServiceTop3 = ({ top3Rates, handleChooseRate }: Props) => {
  return (
    <Row className="mb-5 mt-3 w-75 mx-auto">
      <Col>
        <RateDetailsPopover
          rate={top3Rates[0].price}
          id={"rdp1"}
          service={top3Rates[0].carrierName}
          account={top3Rates[0].account}
          carrierName={top3Rates[0].carrierName}
          noRate
        >
          <Card
            className={`shadow-lg ${classes.cardGeneral}`}
            onClick={handleChooseRate}
          >
            <CardHeader className={classes.cardHeader}>Fastest</CardHeader>
            <CardBody className="text-center">
              <div>
                <h4 className="fw-bold d-flex justify-content-center align-items-center">
                  <Image
                    alt={`${top3Rates[0].carrierName} Logo`}
                    src={
                      top3Rates[0].service.serviceName !== "SV Big Savings"
                        ? `${carrierLogosUrl}${top3Rates[0].carrierName.toLowerCase()}.png`
                        : `/logoShipvista.png`
                    }
                    width={54}
                    height={54}
                  />
                  {top3Rates[0].price.currency}${" "}
                  {top3Rates[0].price.totalCharge}
                </h4>
              </div>
              <div>{top3Rates[0].service.serviceName}</div>
              <div className="fw-bold">
                {top3Rates[0].transitDay
                  ? `${top3Rates[0].transitDay} ${
                      top3Rates[0].transitDay === 1 ? "day" : "days"
                    }`
                  : `Time Not Guarantee`}
              </div>
            </CardBody>
          </Card>
        </RateDetailsPopover>
      </Col>
      <Col>
        <RateDetailsPopover
          rate={top3Rates[1].price}
          id={"rdp2"}
          service={top3Rates[1].carrierName}
          account={top3Rates[1].account}
          carrierName={top3Rates[1].carrierName}
          noRate
        >
          <Card
            className={`${classes.cardRecommended} shadow-lg`}
            onClick={handleChooseRate}
          >
            <CardHeader className={classes.cardHeader}>Recommended</CardHeader>
            <CardBody className="text-center">
              <div>
                <h4 className="fw-bold d-flex justify-content-center align-items-center">
                  <Image
                    alt={`${top3Rates[1].carrierName} Logo`}
                    src={
                      top3Rates[1].service.serviceName !== "SV Big Savings"
                        ? `${carrierLogosUrl}${top3Rates[1].carrierName.toLowerCase()}.png`
                        : `/logoShipvista.png`
                    }
                    width={54}
                    height={54}
                  />
                  {top3Rates[1].price.currency}${" "}
                  {top3Rates[1].price.totalCharge}
                </h4>
              </div>
              <div>{top3Rates[1].service.serviceName}</div>
              <div className="fw-bold">
                {top3Rates[1].transitDay
                  ? `${top3Rates[1].transitDay} ${
                      top3Rates[1].transitDay === 1 ? "day" : "days"
                    }`
                  : `Time Not Guarantee`}
              </div>
            </CardBody>
          </Card>
        </RateDetailsPopover>
      </Col>
      <Col>
        <RateDetailsPopover
          rate={top3Rates[2].price}
          id={"rdp3"}
          service={top3Rates[2].carrierName}
          account={top3Rates[2].account}
          carrierName={top3Rates[2].carrierName}
          noRate
        >
          <Card
            className={`shadow-lg ${classes.cardGeneral}`}
            onClick={handleChooseRate}
          >
            <CardHeader className={classes.cardHeader}>Cheapest</CardHeader>
            <CardBody className="text-center">
              <div>
                <h4 className="fw-bold d-flex justify-content-center align-items-center">
                  <Image
                    alt={`${top3Rates[2].carrierName} Logo`}
                    src={
                      top3Rates[2].service.serviceName !== "SV Big Savings"
                        ? `${carrierLogosUrl}${top3Rates[2].carrierName.toLowerCase()}.png`
                        : `/logoShipvista.png`
                    }
                    width={54}
                    height={54}
                  />
                  {top3Rates[2].price.currency}${" "}
                  {top3Rates[2].price.totalCharge}
                </h4>
              </div>
              <div>{top3Rates[2].service.serviceName}</div>
              <div className="fw-bold">
                {top3Rates[2].transitDay
                  ? `${top3Rates[2].transitDay} ${
                      top3Rates[2].transitDay === 1 ? "day" : "days"
                    }`
                  : `Time Not Guarantee`}
              </div>
            </CardBody>
          </Card>
        </RateDetailsPopover>
      </Col>
    </Row>
  );
};

export default ChooseServiceTop3;
